import { GridColDef } from "@mui/x-data-grid";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { generatePath } from "react-router";

import GaiaDataGrid from "~/modules/app/components/GaiaTable";
import GaiaTableLinkCell from "~/modules/app/components/GaiaTableLinkCell";

import { ObservationTypeDataGridFragment } from "./fragments.generated";

interface Props {
    observationTypes: ObservationTypeDataGridFragment[];
}

export default function ObservationTypeDataGrid({ observationTypes }: Props) {
    const { t } = useTranslation("researchType");

    const columns: GridColDef[] = useMemo(
        () => [
            {
                field: "name",
                headerName: t("observationTypeDataGrid.headerName"),
                flex: 1,
            },
            {
                field: "description",
                headerName: t("observationTypeDataGrid.headerDescription"),
                flex: 1,
            },
            {
                type: "actions",
                field: `id`,
                headerName: "",
                maxWidth: 40,
                valueGetter: (observationTypeId, row) =>
                    generatePath("/admin/settings/researchType/:researchTypeId/observationType/:observationTypeId/", {
                        observationTypeId,
                        researchTypeId: row.researchTypeId,
                    }),
                renderCell: props => <GaiaTableLinkCell value={props.value} />,
            },
        ],
        [t],
    );
    return <GaiaDataGrid rows={observationTypes} columns={columns} rowCount={observationTypes.length} />;
}
